import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { Instagram, Mail } from "lucide-react";

export const Footer = () => (
  <footer className="bg-forest-deep text-cream" data-testid="site-footer">
    <div className="max-w-[1400px] mx-auto px-5 sm:px-8 py-16 sm:py-20">
      <div className="grid md:grid-cols-[1.4fr_1fr_1fr] gap-12">
        <div>
          <Logo dark />
          <p className="font-serif italic text-2xl sm:text-3xl mt-6 max-w-md text-cream/90 leading-snug">
            Your guests have more to say than a signature.
          </p>
          <p className="text-cream/50 text-sm mt-6 max-w-sm">
            A vintage video guestbook, set up at your celebration across the Lower Mainland.
          </p>
        </div>

        <div>
          <p className="text-cream/40 text-xs uppercase tracking-[0.2em] mb-5">Explore</p>
          <ul className="space-y-3 text-cream/80">
            {[["/how-it-works", "How It Works"], ["/packages", "Packages & Pricing"], ["/gallery", "Gallery"], ["/faq", "FAQ"], ["/about", "About"], ["/metro-vancouver", "Metro Vancouver (coming soon)"]].map(([to, label]) => (
              <li key={to}><Link to={to} className="hover:text-cream transition-colors">{label}</Link></li>
            ))}
          </ul>
        </div>

        <div>
          <p className="text-cream/40 text-xs uppercase tracking-[0.2em] mb-5">Get in touch</p>
          <a href="mailto:admin@theeventclub.ca" className="flex items-center gap-2 text-cream/80 hover:text-cream transition-colors mb-3">
            <Mail size={16} /> admin@theeventclub.ca
          </a>
          <a href="https://instagram.com/thee.ventclub" target="_blank" rel="noreferrer" className="flex items-center gap-2 text-cream/80 hover:text-cream transition-colors mb-6">
            <Instagram size={16} /> @thee.ventclub
          </a>
          <Link to="/book" data-testid="footer-book-cta" className="inline-block rounded-full bg-cream text-forest-deep px-6 py-3 text-sm font-medium hover:bg-sand transition-colors">
            Check Your Date
          </Link>
        </div>
      </div>

      <div className="mt-16 pt-8 border-t border-cream/15 flex flex-col sm:flex-row justify-between gap-4 text-cream/40 text-xs">
        <span>© {new Date().getFullYear()} The Event Club. Serving the Lower Mainland.</span>
        <span className="font-serif italic text-cream/50">Real moments, analog memories.</span>
      </div>
    </div>
  </footer>
);
